<script>
import { ValidationObserver } from 'vee-validate'
import { services } from '@utils/common-services'
export default {
  components: {
    ValidationObserver,
  },
  props: {
    menu: {
      type: Object,
      required: true,
    },
    edit: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      trySpin: false,
      roleName: null,
      isStaff: null,
      dashboard: null,
      permissions: null,
      permission: null,
      editPermission: null,
      message: null,
      errorShow: false,
      staffOptions: [
        { id: 1, code: true, label: 'Yes' },
        {
          id: 2,
          code: false,
          label: 'No',
        },
      ],
      id: null,
    }
  },
  computed: {
    placeholders() {
      return {
        roleName: 'Role name',
      }
    },
  },
  watch: {
    edit(newVal, oldVal) {
      if (Object.keys(this.edit).length > 0) {
        this.id = this.edit.id

        this.roleName = this.edit.name
        this.dashboard = this.edit.dashboard
        this.isStaff = this.edit.isStaff
        this.editPermission = this.edit.resourcePermissions
      } else {
        this.id = null
        this.roleName = null
        this.dashboard = null
        this.isStaff = null
        this.editPermission = null
      }
    },
  },
  mounted() {
    if (Object.keys(this.edit).length > 0) {
      this.id = this.edit.id

      this.roleName = this.edit.name

      this.dashboard = this.edit.dashboard
      this.isStaff = this.edit.isStaff
      this.editPermission = this.edit.resourcePermissions
    } else {
      this.id = null
      this.roleName = null
      this.dashboard = null
      this.isStaff = null
      this.editPermission = null
    }
  },
  beforeDestroy() {
    //  this.$store.commit('jv/clearRecords', { _jv: { type: 'role' } })
  },
  methods: {
    /*   staffUpdate(event){
      this.isStaff=event
      this.$root.$emit('isStaff',this.isStaff)
    }, */
    saveRole() {
      var payload = {}
      //    console.log(this.id)

      if (this.id === null) {
        payload = {
          name: this.roleName,
          isStaff: this.isStaff,
          dashboard: this.dashboard,
          resourcePermissions: this.permissions,
          _jv: {
            type: 'role',
          },
        }
      } else {
        payload = {
          name: this.roleName,
          isStaff: this.isStaff,
          dashboard: this.dashboard,
          resourcePermissions: this.permissions,
          _jv: {
            type: 'role',
            id: this.id,
          },
        }
      }
      if (this.id === null) {
        this.$store
          .dispatch('jv/post', [
            payload,
            {
              url: '/accounts/roles',
              headers: services.getHeaderAuthorization(),
            },
          ])
          .then((response) => {
            this.permission = response.resourcePermissions
            this.message = 'New role is created'
            this.$bvToast.show('permission')
            var parent = this
            setTimeout(() => {
              parent.$bvToast.hide('permission')
              parent.message = null
            }, 1000)
          })
          .catch((err) => {
            this.message = err.data.error.detail
            this.errorShow = true
            this.$bvToast.show('permission')
            var parent = this
            setTimeout(() => {
              parent.errorShow = false
              parent.$bvToast.hide('permission')
              parent.message = null
            }, 1000)
          })
      } else {
        this.$store
          .dispatch('jv/patch', [
            payload,
            {
              url: '/accounts/roles/' + this.id,
              headers: services.getHeaderAuthorization(),
            },
          ])
          .then((response) => {
            this.permission = response.resourcePermissions
            this.message = 'Role is updated'
            this.$bvToast.show('permission')
            var parent = this
            setTimeout(() => {
              parent.$bvToast.hide('permission')
              parent.message = null
            }, 1000)
          })
          .catch((err) => {
            this.message = err.data.error.detail
            this.errorShow = true
            this.$bvToast.show('permission')
            var parent = this
            setTimeout(() => {
              parent.errorShow = false
              parent.$bvToast.hide('permission')
              parent.message = null
            }, 1000)
          })
      }
    },
    setPermission(permission) {
      //   console.log(permission)
      this.permissions = []
      this.permissions = permission
    },
  },
}
</script>
<template>
  <div class="mb30">
    <ValidationObserver ref="role" v-slot="{ handleSubmit }">
      <form :class="$style.form" @submit.prevent="handleSubmit(saveRole)">
        <div :class="$style.rolesWraper">
          <div class="clear d-xl-block d-sm-block d-md-none"></div>

          <CommonBaseInputText
            id="roleName"
            v-model="roleName"
            type="text"
            form="role"
            name="roleName"
            :placeholder="placeholders.roleName"
            :validation="{ required: true }"
            label="Role Name"
          />
          <CommonBaseSelectDynamic
            id="selectdashboard"
            v-model="dashboard"
            form="role"
            name="dashboard"
            :validation="{ required: true }"
            label="Dashboard"
            :options="{
              to: '/accounts/roles',
            }"
            @update="dashboard = $event"
          />
          <div class="clear"></div>
          <CommonBaseRadio
            v-model="isStaff"
            name="isStaff"
            label="isStaff"
            :more="{ options: staffOptions }"
            :validation="{ required: true }"
            @update="isStaff = $event"
          />

          <StaffBaseRoleManageTree
            v-if="menu !== null"
            :menu="menu"
            :staff="isStaff"
            :permission="editPermission"
            @update="setPermission"
          />

          <div class="clear"></div>

          <div :class="[$style.buttonWrapper]" class="">
            <!--  <button class="buttonCommon buttonCancel button mr10">
                    Cancel
                  </button> -->
            <button
              class="buttonCommon buttonPrimary button"
              type="submit"
              v-on="$listeners"
            >
              <b-spinner
                v-if="trySpin"
                style="width: 18px; height: 18px;"
                class="ml15 mr15"
                label="Spinning"
              ></b-spinner>
              {{ !trySpin ? (id === null ? 'Add' : 'Update') : '' }}
            </button>
          </div>
        </div>
      </form>
    </ValidationObserver>
    <div :class="$style.toasterMainWrap">
      <b-toast id="permission" solid no-auto-hide>
        <div
          class="d-flex"
          :class="[$style.loginToasterWraper, $style.success]"
        >
          <div :class="$style.toasterLeft">
            <BIcon
              icon="chat-square-dots-fill"
              :class="$style.toasterIcon"
            ></BIcon>
          </div>
          <div :class="$style.toasterRight">
            <strong class="mr-auto" :class="$style.toasterHeader"
              >Notice!</strong
            >
            <p :class="$style.toasterContent">{{ message }}</p>
          </div>
          <div class="clear"></div>
        </div>
      </b-toast>
    </div>
  </div>
</template>
<style lang="scss" module>
@import '@design';

.rolesWraper {
  padding: 20px;
  label {
    width: 100% !important;
  }
}
</style>
